module.exports = __webpack_public_path__ + "img/borderWaves.4e5fb255.svg";